import ReactHtmlParser from 'react-html-parser';

import { Button } from '@ce-cfbdigital/cgl-cfb-fe-foundation';
import PropTypes from 'prop-types';

import CustomIcon from '../CustomIcons';

import './styles/index.css';

const COLORS = {
  green: '#658d1b',
  aqua: '#279989',
  yellow: '#daaa00',
  gold: '#cf7f00',
  orange: '#be531c',
  red: '#9e2a2f',
  grey: '#333'
};

const StickyBanner = ({
  message,
  color,
  buttonText,
  isCloseIcon,
  containerClass,
  handleClick,
  isStickyBannerClosed,
  isFullMessage,
  elementRef
}) => {
  if (!message) return null;
  const backgroundColor = COLORS[color];

  return (
    <div
      className={`${isStickyBannerClosed ? 'sticky-banner__hide' : ''} sticky-banner ${containerClass}`}
      style={{ backgroundColor }}
      ref={elementRef}
    >
      <div className={isFullMessage ? 'sticky-banner__message' : ''}>
        {isFullMessage ? (
          <>
            <CustomIcon type="info" size="24" className="info-icon" />
            <span className="sticky-banner__bold">{ReactHtmlParser(message)}</span>
          </>
        ) : (
          ReactHtmlParser(message)
        )}
      </div>
      {buttonText && <Button buttonLabel={buttonText} classes="sticky-banner__btn" handleClick={handleClick} />}
      {isCloseIcon ? (
        <div className="sticky-banner__close-icon" role="presentation" onClick={handleClick} onKeyUp={handleClick}>
          <CustomIcon type="close" size="24" />
        </div>
      ) : null}
    </div>
  );
};

StickyBanner.propTypes = {
  handleClick: PropTypes.func.isRequired,
  isStickyBannerClosed: PropTypes.bool.isRequired,
  elementRef: PropTypes.shape({ current: PropTypes.instanceOf(HTMLDivElement) }).isRequired,
  message: PropTypes.string,
  isFullMessage: PropTypes.bool,
  containerClass: PropTypes.string,
  isCloseIcon: PropTypes.bool,
  buttonText: PropTypes.string,
  color: PropTypes.string
};

StickyBanner.defaultProps = {
  message: '',
  containerClass: '',
  isCloseIcon: false,
  isFullMessage: false,
  buttonText: null,
  color: '#658d1b'
};

export default StickyBanner;
